import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProductDescriptionProps {
  description: string;
  usage: string[];
  tags: string[];
  tokenId: string;
}

export default function ProductDescription({
  description,
  usage,
  tags,
  tokenId,
}: ProductDescriptionProps) {
  const { t } = useTranslation(); // useTranslation 훅 사용

  return (
    <div className="py-5 px-4 mt-6">
      <div className="w-full">
        <div className="break-words overflow-hidden whitespace-pre-wrap">
          <h2 className="text-[15px] mobile:text-sm text-MainTextColor Pretendard-Bold">
            {t('descriptionTitle')}
          </h2>
          <div
            className="pl-6 text-sm mobile:text-xs mobile:leading-[24px] mobile:mt-2 leading-10 Pretendard-Regular text-[#7e7e7e] w-full"
            dangerouslySetInnerHTML={{ __html: description }}
          />

          <h2 className="text-[15px] mobile:text-sm text-MainTextColor Pretendard-Bold mt-6">
            📁 {t('usageTitle')}
          </h2>
          <ul className="pl-6 text-sm leading-6 mobile:text-xs mobile:mt-2 mobile:leading-[24px] Pretendard-Regular text-[#7e7e7e] w-full">
            {usage.map((item, index) => (
              <li key={index} className="mt-2">
                <span dangerouslySetInnerHTML={{ __html: item }} />
              </li>
            ))}
          </ul>

          <h2 className="text-[15px] mobile:text-sm text-MainTextColor Pretendard-Bold mt-6">
            {t('tagsTitle')}
          </h2>
          <p className="pl-6 text-sm leading-10 mobile:text-xs mobile:mt-2 mobile:leading-[24px] Pretendard-Regular text-[#7e7e7e] w-full">
            <span dangerouslySetInnerHTML={{ __html: tags.join(', ') }} />
          </p>

          <h2 className="text-[15px mobile:text-sm text-MainTextColor Pretendard-Bold mt-6">
            {t('tokenIdTitle')}
          </h2>
          <p className="pl-6 text-sm leading-10 mobile:text-xs mobile:mt-2 mobile:leading-[24px] Pretendard-Regular text-[#7e7e7e] w-full">
            {tokenId}
          </p>
        </div>
      </div>
    </div>
  );
}
